module.exports = "<div *ngIf=\"!!isLoading\" class=\"loading-container\">\r\n    <div class=\"loading\">\r\n        <!-- <nz-spin [nzTip]=\"'加载中...'\" [nzSize]=\"'large'\"></nz-spin> -->\r\n        <span class=\"throbber-loader\">{{'shared.loading' | translate}}&#8230;</span>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/shared/components/loading/loading.component.html
// module id = ../../../../../src/app/shared/components/loading/loading.component.html
// module chunks = main